export const HOME_IDS = {
  title: "home-title",
  prepareBtn: "home-prepare-btn",
  viewListBtn: "home-view-list-btn",
  mascot: "home-mascot",
};

export const IMPORT_IDS = {
  urlInput: "import-url-input",
  portionsSelect: "import-portions-select",
  generateBtn: "import-generate-btn",
  manualBtn: "import-manual-btn",
  backBtn: "import-back-btn",
  validateModal: "validate-modal",
  validateConfirm: "validate-confirm-btn",
  validateCancel: "validate-cancel-btn",
  manualModal: "manual-modal",
  manualName: "manual-name-input",
  manualQty: "manual-qty-input",
  manualUnit: "manual-unit-select",
  manualRecipe: "manual-recipe-input",
  manualAdd: "manual-add-btn",
  manualConfirm: "manual-confirm-btn",
};

export const LIST_IDS = {
  container: "list-container",
  addRecipeBtn: "list-add-recipe-btn",
  addItemBtn: "list-add-item-btn",
  resetBtn: "list-reset-btn",
  shareBtn: "list-share-btn",
  homeBtn: "list-home-btn",
};
